import Button from 'components/button/Button';
import CheckboxGroup from 'components/checkbox-group/CheckboxGroup';
import Form from 'components/form/Form';
import Link from 'components/link/Link';
import NewsletterAdministrationLayout from 'components/newsletter-administration-layout/NewsletterAdministrationLayout';
import TextInput from 'components/form-elements/text-input/TextInput';
import Validation from 'components/validation/Validation';

import { INewsletterAdminPage } from 'source/NFR.types';

const NewsletterAdminPage: React.FC<INewsletterAdminPage> = ({
  checkboxGroups = [],
  form,
  inputFieldsTitle,
  inputFieldsItems = [],
  layout,
  submitButton,
  title,
  unsubscribeLink,
  validation
}) => (
  <NewsletterAdministrationLayout {...layout} className="newsletter-admin-page">
    <Form {...form} showSubmitButton={false}>
      {title && <h1>{title}</h1>}
      {validation && <Validation {...validation} />}
      <div className="newsletter-admin-page--input-fields">
        {inputFieldsTitle && <h2>{inputFieldsTitle}</h2>}
        {inputFieldsItems?.map(input => (
          <TextInput className="newsletter-admin-page--text-input" key={input.name} type="text" {...input} />
        ))}
      </div>
      {checkboxGroups?.map(checkboxGroup => (
        <CheckboxGroup key={checkboxGroup.title} {...checkboxGroup} />
      ))}
      <div className="newsletter-admin-page--button-wrapper">
        <Button theme={['primary', 'large']} type="submit" {...submitButton} />
        <Link className="newsletter-admin-page--unsubscribe-link" theme="underline" {...unsubscribeLink} />
      </div>
    </Form>
  </NewsletterAdministrationLayout>
);

NewsletterAdminPage.displayName = 'NewsletterAdminPage';

export default NewsletterAdminPage;
